import React, { useState } from 'react';
import './Slider.css';

const Slider = ({ min = 0, max = 100, initialValue = 50, onChange }) => {
    const [value, setValue] = useState(initialValue);

    const handleInputChange = (e) => {
        const newValue = Number(e.target.value);
        setValue(newValue);
        if (onChange) {
            onChange(newValue);
        }
    };

    const percent = ((value - min) / (max - min)) * 100;

    return (
        <div className='Slider'>
            <input 
                type="range" 
                min={min} 
                max={max} 
                value={value} 
                onChange={handleInputChange} 
                className="HiddenSliderInput"
            />

            <div 
                className='SliderBar' 
                style={{ width: `${percent}%` }}
            ></div>
            
            <div 
                className='SliderPuck' 
                style={{ left: `calc(${percent}% - 15px)` }}
            ></div>
        </div>
    );
};

export default Slider;